module.exports = __webpack_public_path__ + "static/media/robot.39188ca0.png";